import restClient from '@/shared/restClient/restClient.service.js';

export default {

    clearUserCache: (request, loader) => {
        return restClient.Post('/api/User/ClearUserCache', request, null, loader).then((data) => data);
    },

    list: function (request, loader) {
        return restClient.Get('/api/User/list', request, null, loader).then((data) => data);
    },

    combo: (request, loader) => {
        return restClient.Get('/api/User/combo', request, null, loader).then((data) => data);
    },

    addReq: (request, loader) => {
        return restClient.Post('/api/User/addReq', request, null, loader).then((data) => data);
    },

    editReq: (request, loader) => {
        return restClient.Put('/api/User/editReq', request, null, loader).then((data) => data);
    },

    deleteReq: (request, loader) => {
        return restClient.Delete('/api/User/deleteReq', request, null, loader).then((data) => data);
    },

    assignProfile: (request, loader) => {
        return restClient.Post('/api/User/assignProfile', request, null, loader).then((data) => data);
    },

    unassignProfile: (request, loader) => {
        return restClient.Post('/api/User/unassignProfile', request, null, loader).then((data) => data);
    },

    getASAUserExample: (request, loader) => {
        return restClient.Get('/api/User/ASAUser',request,null, loader).then((data) => data);
    },

};
